// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2V0e6","title":"Images45_title__3gDJQ","images":"Images45_images__3Vaab"};